<template>
  <div id="app" >
    <router-view></router-view>  
  </div>


</template>


<script>
/*
       名称：vue纯前端Demo下载网站源码
       功能：完成前端的各种交互，如数据绑定，列表显示，点击事件，页面跳转，页面间传参，数据处理，图片显示
       作者：唐赢   
       时间：2022-11-30
*/


export default {
  name: 'App',
  data() {
    return {

    }
  },
  methods:  {
  }
  

}
</script>

<style>
  html,body{
    margin:0;
    padding:0;
    border:0px;
    background-color: #fafafa;
  }

  html[theme='gray-mode']{
	-webkit-filter: grayscale(100%);
	-moz-filter: grayscale(100%);
	-ms-filter: grayscale(100%);
	-o-filter: grayscale(100%);
	filter:progid: DXImageTransform.Microsoft.BasicImage(grayscale=1);
	_filter:none;
}


  
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
  

</style>



// WEBPACK FOOTER //
// src/App.vue